import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { HowItWorks } from './components/HowItWorks';
import { CoreBenefit } from './components/CoreBenefit';
import { Features } from './components/Features';
import { SocialProof } from './components/SocialProof';
import { PerfectFor } from './components/PerfectFor';
import { ProductVisual } from './components/ProductVisual';
import { UrgencyCTA } from './components/UrgencyCTA';
import { FAQ } from './components/FAQ';
import { StickyBuyButton } from './components/StickyBuyButton';
export function App() {
  useEffect(() => {
    // Meta Pixel — initialize fbq inline first
    const w = window as any;
    if (!w.fbq) {
      const n: any = w.fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      if (!w._fbq) w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
    }
    // Load the fbevents.js SDK
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    // Init and track after SDK is ready
    script.onload = () => {
      w.fbq('init', '975129441692961');
      w.fbq('track', 'PageView');
    };
    // Also call init/track immediately in case SDK loads fast
    try {
      w.fbq('init', '975129441692961');
      w.fbq('track', 'PageView');
    } catch (e) {
      // SDK not ready yet, onload will handle it
    }
    // noscript fallback image
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=975129441692961&ev=PageView&noscript=1';
    document.body.appendChild(img);
    return () => {
      if (script.parentNode) script.parentNode.removeChild(script);
      if (img.parentNode) img.parentNode.removeChild(img);
    };
  }, []);
  return <div className="min-h-screen bg-dark font-sans text-cream selection:bg-gold/30 selection:text-cream pb-24 md:pb-0" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <ProblemSection data-id="element-3" />
        <SolutionSection data-id="element-4" />
        <HowItWorks data-id="element-5" />
        <CoreBenefit data-id="element-6" />
        <Features data-id="element-7" />
        <SocialProof data-id="element-8" />
        <PerfectFor data-id="element-9" />
        <ProductVisual data-id="element-10" />
        <UrgencyCTA data-id="element-11" />
        <FAQ data-id="element-12" />
      </main>

      <footer className="bg-dark border-t border-gold/10 py-8 text-center text-cream-dark/50 text-sm" data-id="element-13">
        <p data-id="element-14">
          © {new Date().getFullYear()} TapShare Events. All rights reserved.
        </p>
      </footer>

      <StickyBuyButton data-id="element-15" />
    </div>;
}